import React from 'react';

const Map = () => {
    return (
        <>
            <div className=' mx-auto sm:max-w-xl md:max-w-full mb-20 mx-auto' id='cuando'>
                <div className='p-8 rounded sm:p-16 -mt-48 bg-celeste_rancagua mx-auto' id='donde'>
                    <div>
                        <div className='grid sm:grid-cols-1 lg:grid-cols-2 mx-auto'>
                            <h2 className='font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none mt-14 text-white text-justify'>
                                16 al 21 y 25 de ENERO 2023
                                <br className='' />
                                Casa de la Cultura Rancagua y UOH Rancagua {' '}
                            </h2>
                            <div className='md:ml-20 md:mt-0 mt-10'>
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1650.420214631497!2d-70.74198537410217!3d-34.17599722279116!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x96634338b5b928f1%3A0xa1e32c0847ae06d9!2sCachapoal%2C%20Municipalidad%20de%20Rancagua%2FCasa%20de%20la%20Cul%20Tura%2C%20Rancagua%2C%20O&#39;Higgins!5e0!3m2!1ses!2scl!4v1672929366770!5m2!1ses!2scl"
                                    title='mapa casa de la cultura'
                                    className='w-full'
                                    style={{height: '200px', width: '95%'}}
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Map;